import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import './Tiles.css';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import { ButtonWrapper, LinkWrapper } from '../LinkWrapper/LinkWrapper';
import { wrapTrademarkSuperscript } from '../../utils/cob-utils';
import { Row, Col, Title, Section, Icon } from '../../importCL';

interface IFaqCard {
    icon?: string;
    text?: string;
    altText?: string;
    link?: string;
}

interface Icon {
    iconAltText: string;
    iconLabel: string;
    iconPath: string;
    uuid: string;
}

interface ITilesProps extends MappedComponentProperties {
    faqLinkText?: string;
    faqLink?: string;
    faqCards?: IFaqCard[];
    icons?: Icon[];
    faqWidth?: boolean; // Not provided by TilesModelImpl, used in TilesOrLinks.tsx for FAQLinks
}

export const TilesEditConfig = {
    emptyLabel: 'Tiles',
    isEmpty: (props: PropsWithChildren<ITilesProps>) => {
        return !props || !props.faqCards;
    },
};

const Tiles = (props: PropsWithChildren<ITilesProps>): JSX.Element => {
    return (
        <div id='tiles' className='Tiles py-16 bg-white'>
            <Section className='!p-0'>
                <Row className='justify-start'>
                    {props.faqCards && props.faqCards.map((faqCard: IFaqCard, index: number) => (
                        <Col key={index} sm={12} md={props.faqWidth ? 12 : 6} lg={props.faqWidth ? 6 : 4}>
                            <LinkWrapper className='Tiles__cardTile hover:border-blue-cobalt' href={faqCard.link}>
                                {props.icons && props.icons[index] &&
                                    <Icon loading='lazy' src={props.icons[index].iconPath} alt={props.icons[index].iconAltText} />}
                                <Title className='text-[1.125rem] mb-0 leading-6 flex-1' tag='h3'>
                                    {transformHTMLParserLinks(wrapTrademarkSuperscript(faqCard.text))}
                                </Title>
                            </LinkWrapper>
                        </Col>
                    ))}
                </Row>
                <div className='flex justify-center items-center'>
                    {props.faqLinkText && <ButtonWrapper className='mt-8 mb-0 border-none !py-2.5 !px-6' variant='link' icon='chevron' size='medium'
                        href={props.faqLink}>{transformHTMLParserLinks(wrapTrademarkSuperscript(props.faqLinkText))}</ButtonWrapper>}
                </div>
            </Section>
        </div>
    );
};

export default Tiles;

